import * as universal_hooks from '../../../src/hooks.ts';

export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28'),
	() => import('./nodes/29'),
	() => import('./nodes/30'),
	() => import('./nodes/31'),
	() => import('./nodes/32'),
	() => import('./nodes/33'),
	() => import('./nodes/34'),
	() => import('./nodes/35'),
	() => import('./nodes/36'),
	() => import('./nodes/37'),
	() => import('./nodes/38'),
	() => import('./nodes/39')
];

export const server_loads = [0,2,3];

export const dictionary = {
		"/[lang]": [~7,[2]],
		"/[lang]/app": [9,[2]],
		"/[lang]/bonus": [10,[2]],
		"/[lang]/casino": [~11,[2,3]],
		"/[lang]/casino/favorites": [~13,[2,3]],
		"/[lang]/casino/[slug]": [~12,[2,3]],
		"/[lang]/coming-soon": [14,[2]],
		"/[lang]/faq": [15,[2,4]],
		"/[lang]/faq/[slug]": [16,[2,4]],
		"/[lang]/fiat-payment": [17,[2]],
		"/[lang]/game": [18,[2,5]],
		"/[lang]/game/restriction": [20,[2,5]],
		"/[lang]/game/[slug]": [~19,[2,5]],
		"/[lang]/jemka": [21,[2]],
		"/[lang]/level-up": [22,[2]],
		"/[lang]/not-allowed": [23,[2]],
		"/[lang]/profile": [24,[2,6]],
		"/[lang]/profile/account-details": [25,[2,6]],
		"/[lang]/profile/change-password": [26,[2,6]],
		"/[lang]/profile/gallop-network": [27,[2,6]],
		"/[lang]/profile/rollover": [28,[2,6]],
		"/[lang]/profile/security": [29,[2,6]],
		"/[lang]/profile/self-exclusion": [30,[2,6]],
		"/[lang]/profile/transactions": [31,[2,6]],
		"/[lang]/promotions": [~32,[2]],
		"/[lang]/promotions/[slug]": [~33,[2]],
		"/[lang]/providers": [34,[2]],
		"/[lang]/providers/[slug]": [~35,[2]],
		"/[lang]/reset-password": [36,[2]],
		"/[lang]/sports": [~37,[2]],
		"/[lang]/tag/[slug]": [38,[2]],
		"/[lang]/verify-email": [39,[2]],
		"/[lang]/[static]": [8,[2]]
	};

export const hooks = {
	handleError: (({ error }) => { console.error(error) }),
	
	reroute: universal_hooks.reroute || (() => {}),
	transport: universal_hooks.transport || {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export { default as root } from '../root.js';